"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var react_redux_1 = require("react-redux");
require("react-toastify/dist/ReactToastify.css");
var react_toastify_1 = require("react-toastify");
require("./styles.scss");
var model_1 = require("../../model");
var constants_1 = require("../../constants");
var Button_1 = require("../_shared/components/Button");
var component_1 = require("../_shared/worklogs/component");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var moment = require("moment");
var actions_1 = require("../_shared/weekDays/actions");
var ApproveModal_1 = require("../_shared/components/approveModal/ApproveModal");
var ClosedOrderModal_1 = require("../_shared/components/closedOrderModal/ClosedOrderModal");
var utils_1 = require("../../helpers/utils");
var Page = /** @class */ (function (_super) {
    __extends(Page, _super);
    function Page(props) {
        var _this = _super.call(this, props) || this;
        _this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, day, ids, selectedUsers;
            return __generator(this, function (_b) {
                _a = this.props.match.params, day = _a.day, ids = _a.ids;
                selectedUsers = ids.split(',');
                this.props.setSelectedUsers(selectedUsers);
                this.props.getWeeklyWorkDays(day, selectedUsers);
                return [2 /*return*/];
            });
        }); };
        _this.onControlButtonClick = function () {
            _this.setState({ mode: ApproveModal_1.MODE_CONTROL });
            var openDays = (0, utils_1.getOpenDays)(_this.props.weekDays, _this.props.selectedUsers);
            if (openDays.length) {
                _this.approveModal && _this.approveModal.openModal();
            }
            else {
                _this.controlWeekDays();
            }
        };
        _this.onAcceptButtonClick = function () {
            _this.setState({ mode: ApproveModal_1.MODE_APPROVE });
            var openDays = (0, utils_1.getOpenDays)(_this.props.weekDays, _this.props.selectedUsers);
            if (openDays.length) {
                _this.approveModal && _this.approveModal.openModal();
            }
            else {
                _this.approveWeekDays();
            }
        };
        _this.onUnacceptButtonClick = function () {
            _this.setState({ mode: ApproveModal_1.MODE_UNDO_APPROVE });
            var openDays = (0, utils_1.getOpenDays)(_this.props.weekDays, _this.props.selectedUsers);
            if (openDays.length) {
                _this.approveModal && _this.approveModal.openModal();
            }
            else {
                _this.undoApproveWeekDays();
            }
        };
        _this.state = {
            mode: ApproveModal_1.MODE_APPROVE
        };
        return _this;
    }
    Page.prototype.componentWillMount = function () {
        if (this.props.selectedUsers.length === 0) {
            this.loadData();
        }
    };
    Page.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.hasClosedOrders && this.props.hasClosedOrders !== prevProps.hasClosedOrders) {
            this.closedOrderModal && this.closedOrderModal.openModal(this.state.mode);
        }
    };
    Page.prototype.controlWeekDays = function (ignoreClosedOrders) {
        var date = this.props.weekDays[0].workDays[0].date;
        this.props.controlWeekDays(date, this.props.selectedUsers, this.props.requestDate, ignoreClosedOrders);
    };
    Page.prototype.approveWeekDays = function (ignoreClosedOrders) {
        var date = this.props.weekDays[0].workDays[0].date;
        this.props.approveWeekDays(date, this.props.selectedUsers, this.props.requestDate, ignoreClosedOrders);
    };
    Page.prototype.undoApproveWeekDays = function () {
        var date = this.props.weekDays[0].workDays[0].date;
        this.props.unapproveWeekDays(date, this.props.selectedUsers, this.props.requestDate);
    };
    Page.prototype.navigateToDay = function (userId, date) {
        this.props.history.push('/hour-control-user/' + userId + '/' + date);
    };
    Page.prototype.navigateBack = function () {
        this.props.history.goBack();
    };
    Page.prototype.renderUserRow = function (userId) {
        var _this = this;
        var userWeek = this.props.weekDays.find(function (weekdays) {
            return weekdays.user._id === userId;
        }) || { workDays: [], user: userId, is_approved: false };
        var workDays = _.map(userWeek.workDays, function (workDay) {
            return React.createElement(layout_1.Row, { key: userId + workDay.date },
                React.createElement(layout_1.Column, null,
                    React.createElement(layout_1.Wrapper, { paddingVertical: "16px" },
                        React.createElement(layout_1.Row, null,
                            React.createElement("span", { className: "center worklog-date clickable", onClick: function () { return _this.navigateToDay(userId, workDay.date); } },
                                moment(workDay.date).format(constants_1.DISPLAY_WEEKDAY_DATE_FORMAT),
                                React.createElement("i", { className: "material-icons" }, "remove_red_eye")))),
                    React.createElement(component_1.default, { calledBy: 'weekDays', isApproved: userWeek.is_approved, isClosed: workDay.is_closed, closeMessage: workDay.close_message, projectsGPSHoursMap: workDay.projects, spent_work_time: workDay.spent_work_time, spent_travel_time: workDay.spent_travel_time, date: workDay.date, user: userWeek.user, projects: workDay.projects, worklogs: workDay.worklogs, startTime: workDay.startTime, startTimeSubmittedAt: workDay.startTimeSubmittedAt, timelines: workDay.timelines })),
                React.createElement(layout_1.Margin, { margin: "16px" }));
        });
        return (React.createElement(layout_1.Row, { key: userId }, workDays));
    };
    Page.prototype.renderLogs = function () {
        var _this = this;
        if (this.props.selectedUsers.length === 0) {
            return (React.createElement(layout_1.Center, null, constants_1.NO_DATA_MESSAGE));
        }
        var getControlledMessage = function (userId) {
            var userWeek = _this.props.weekDays.find(function (week) { return week.user._id === userId; });
            if (!userWeek || !userWeek.workWeek) {
                return;
            }
            var worklogWeek = userWeek.workWeek;
            return "Gecontroleerd door ".concat(worklogWeek.controller.firstName, " ").concat(worklogWeek.controller.lastName, " op ").concat(moment(worklogWeek.controlled_at)
                .format('YYYY-MM-DD'), " om ").concat(moment(worklogWeek.controlled_at).format('HH:mm'));
        };
        return this.props.selectedUsers.map(function (userId) {
            var userWeek = _this.props.weekDays.find(function (week) { return week.user._id === userId; });
            return React.createElement(layout_1.Wrapper, { key: userId },
                React.createElement("div", { className: "page-title" }, userWeek ? (0, model_1.getUserFullName)(userWeek.user) : ''),
                getControlledMessage(userId),
                React.createElement("div", { className: "user-row" },
                    _this.renderUserRow(userId),
                    React.createElement(layout_1.Margin, { margin: "32px" })));
        });
    };
    /**
     * We can't approved if there is at least one approved user week
     * @return {boolean}
     */
    Page.prototype.isApproved = function () {
        var _this = this;
        var selectedWeeks = _.filter(this.props.weekDays, function (week) {
            return _.includes(_this.props.selectedUsers, week.user._id);
        });
        return _.some(selectedWeeks, function (week) { var _a; return (_a = week.workWeek) === null || _a === void 0 ? void 0 : _a.is_approved; });
    };
    /**
     * Checks if selected work week has been marked as having an error
     * @return {boolean}
     */
    Page.prototype.hasError = function () {
        var _this = this;
        var selectedWeeks = _.filter(this.props.weekDays, function (week) {
            return _.includes(_this.props.selectedUsers, week.user._id);
        });
        return _.some(selectedWeeks, function (week) { var _a; return (_a = week.workWeek) === null || _a === void 0 ? void 0 : _a.has_approval_error; });
    };
    Page.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_HOURS, id: "users-hour-list", isLoading: this.props.isApproving || this.props.isLoadingWeeklyWorkDays || this.props.isUnapproving, subPages: ['Uren Lijst'] },
            React.createElement(ApproveModal_1.default, { ref: function (ref) { return _this.approveModal = ref; }, onApprove: function () { return _this.approveWeekDays(); }, onUndoApprove: function () { return _this.undoApproveWeekDays(); }, onControl: function () { return _this.controlWeekDays(); }, mode: this.state.mode }),
            React.createElement(ClosedOrderModal_1.default, { orders: this.props.closedOrders, ref: function (ref) { return _this.closedOrderModal = ref; }, onControl: function () { return _this.controlWeekDays(true); }, onApprove: function () { return _this.approveWeekDays(true); } }),
            React.createElement(layout_1.Wrapper, { padding: "16px" },
                React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                    React.createElement("span", { className: "button", onClick: function () { return _this.navigateBack(); } }, "Ga Terug"),
                    React.createElement(layout_1.Margin, { margin: "32px" }),
                    React.createElement(Button_1.default, { onClick: function () { return _this.onControlButtonClick(); }, disabled: this.isApproved(), text: "Controleren" }),
                    this.props.identity && (0, model_1.userHasPermission)(this.props.identity, model_1.Permission.SAVE_HOURS) && (React.createElement(React.Fragment, null,
                        React.createElement(layout_1.Margin, { margin: "32px" }),
                        React.createElement(Button_1.default, { onClick: this.props.identity.role === model_1.UserRoles.ADMIN ?
                                function () { return null; } :
                                function () { return _this.onAcceptButtonClick(); }, disabled: this.isApproved(), text: "Keur Goed" }))),
                    this.hasError() &&
                        this.isApproved() &&
                        ((_a = this.props.identity) === null || _a === void 0 ? void 0 : _a.role) === model_1.UserRoles.ADMIN &&
                        (React.createElement(React.Fragment, null,
                            React.createElement(layout_1.Margin, { margin: "32px" }),
                            React.createElement(Button_1.default, { onClick: function () { return _this.onUnacceptButtonClick(); }, disabled: false, text: "Ongedaan maken" }))))),
            this.renderLogs(),
            React.createElement(react_toastify_1.ToastContainer, null)));
    };
    return Page;
}(React.Component));
var mapStateToProps = function (_) {
    return {
        identity: _.reducer.authentication.user,
        selectedUsers: _.reducer.WeekDaysReducer.selectedUsers,
        weekDays: _.reducer.WeekDaysReducer.weekDays,
        requestDate: _.reducer.WeekDaysReducer.requestDate,
        isApproving: _.reducer.WeekDaysReducer.isApproving,
        isUnapproving: _.reducer.WeekDaysReducer.isUnapproving,
        isLoadingWeeklyWorkDays: _.reducer.WeekDaysReducer.isLoadingWeeklyWorkDays,
        closedOrders: _.reducer.WeekDaysReducer.closedOrders,
        hasClosedOrders: _.reducer.WeekDaysReducer.hasClosedOrders,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    controlWeekDays: function (date, userIds, requestDate, ignoreClosedOrders) {
        return actions_1.Actions.controlWeekDays(date, userIds, requestDate, ignoreClosedOrders)(dispatch);
    },
    approveWeekDays: function (date, userIds, requestDate, ignoreClosedOrders) { return actions_1.Actions.approveWeekDays(date, userIds, requestDate, ignoreClosedOrders)(dispatch); },
    unapproveWeekDays: function (date, userIds, requestDate) { return actions_1.Actions.unapproveWeekDays(date, userIds, requestDate)(dispatch); },
    setSelectedUsers: function (userIds) { return actions_1.Actions.setSelectedUsers(userIds)(dispatch); },
    getWeeklyWorkDays: function (date, userIds) {
        return actions_1.Actions.getWeeklyWorkDays(date, 0, userIds.length, null, null, userIds)(dispatch);
    },
}); };
// @ts-ignore
var UserHoursList = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Page);
exports.default = UserHoursList;
